export default __webpack_public_path__ + "static/9-d02ef553ba6c0ab7c0159c7d5a95a419.jpg";